import React from 'react';
import './nav.scss';

function Nav() {
  return (
    <div className="nav-wrap">
      <div className="nav-body">
        <p href="#">HOME</p>
        <p href="#">CONTACT US</p>
        <p href="#">CURRICULUM OFFICE</p>
        <p href="#">CATALOG</p>
      </div>
    </div>
  );
}

export default Nav;
